export default "__VITE_ASSET__CHMhi0M6__"